import { render, staticRenderFns } from "./simple-info-block.vue?vue&type=template&id=676b6c2b&scoped=true&"
import script from "./simple-info-block.vue?vue&type=script&lang=js&"
export * from "./simple-info-block.vue?vue&type=script&lang=js&"
import style0 from "./simple-info-block.vue?vue&type=style&index=0&id=676b6c2b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676b6c2b",
  null
  
)

export default component.exports